import React from "react";
import styled from "styled-components";

const StyledWrapper = styled.div`
  color: ${ ({theme}) => theme.colorTokens.aliases.text };
  border-radius: ${ ({theme}) => theme.borderRadius };
`;

export const BankLoginPage = ({lang, children}) => {

    const translations = {
        en: {
            nav: {
                features: 'Bank321',
                operations: 'Operations',
                testimonials: 'Testimonials',
            },
            header: {
                when: 'When ',
                banking: 'banking ',
                meets: 'meets ',
                minimalist: 'minimalist',
                tagline: 'A simpler banking experience for a simpler life.',
                learnMore: 'Learn more'
            },
            operations: {
                title: 'Operations',
                tagline: 'Everything as simple as possible, but no simpler.',
                instantTransfers: 'Instant Transfers',
                instantLoans: 'Instant Loans',
                instantClosing: 'Instant Closing',
                transfersHeader: 'Transfer money to anyone, instantly! No fees, no BS.'
            }
        },
        et: {
            nav: {
                features: 'Bank321',
                operations: 'Võimalused',
                testimonials: 'Meist',
            },
            header: {
                when: 'Kui ',
                banking: 'pank ',
                meets: 'kohtub ',
                minimalist: 'minimalismiga',
                tagline: 'Lihtsam pangandus lihtsamaks eluks.',
                learnMore: 'Uuri lähemalt'
            },
            operations: {
                title: 'Võimalused',
                tagline: 'Kõik nii lihtsalt kui võimalik, aga mitte lihtsamini.',
                instantTransfers: 'Välkmaksed',
                instantLoans: 'Kiirlaenud',
                instantClosing: 'Kiired lepingud',
                transfersHeader: 'Tee ülekandeid ükskõik kellele, silmapilkselt. Ei mingeid peidetud tasusid!'
            }
        },
        lv: {
            nav: {
                features: 'Bank321',
                operations: 'Operācijas',
                testimonials: 'Atsauks',
            },
            header: {
                when: 'Kad ',
                banking: 'banka ',
                meets: 'sanāk ',
                minimalist: 'minimālistisks',
                tagline: 'Vienkāršāka banku pieredze vienkāršākai dzīvei.',
                learnMore: 'Uzzināt vairāk'
            },
            operations: {
                title: 'Operācijas',
                tagline: 'Viss pēc iespējas vienkāršāks, bet ne vienkāršāks.',
                instantTransfers: 'Tūlītēji pārskaitījumi',
                instantLoans: 'Tūlītējie kredīti',
                instantClosing: 'Tūlītēja aizvēršana',
                transfersHeader: 'Pārskaitiet naudu jebkuram uzreiz!'
            }
        }
    }

    return <StyledWrapper className='bank321'>
        <header className="header bank321">
            <nav className="nav">
                <img
                    src="data:image/svg+xml;base64,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"
                    alt="Bankist logo"
                    className="nav__logo"
                    id="logo"
                    data-version-number="3.0"
                />
                <ul className="nav__links">
                    <li className="nav__item">
                        <a className="nav__link" href="#section--1">{ translations[lang].nav.features }</a>
                    </li>
                    <li className="nav__item">
                        <a className="nav__link" href="#section--2">{ translations[lang].nav.operations }</a>
                    </li>
                    <li className="nav__item">
                        <a className="nav__link" href="#section--3">{ translations[lang].nav.testimonials }</a>
                    </li>
                    <li className="nav__item">
                        {children}
                    </li>
                </ul>
            </nav>

            <div className="header__title">
                <h1>
                    { translations[lang].header.when }
                    <span className="highlight">{ translations[lang].header.banking }</span>
                    { translations[lang].header.meets }<br/>
                    <span className="highlight">{ translations[lang].header.minimalist }</span>
                </h1>
                <h4>{ translations[lang].header.tagline }</h4>
                <button className="btn--text btn--scroll-to">{ translations[lang].header.learnMore }</button>
            </div>
        </header>


        <section className="section" id="section--2">
            <div className="section__title">
                <h2 className="section__description">{ translations[lang].operations.title }</h2>
                <h3 className="section__header">
                    { translations[lang].operations.tagline }
                </h3>
            </div>

            <div className="operations">
                <div className="operations__tab-container">
                    <button
                        className="
              btn
              operations__tab operations__tab--1 operations__tab--active
            "
                        data-tab="1"
                    >
                        <span>01</span>{ translations[lang].operations.instantTransfers }
                    </button>
                    <button className="btn operations__tab operations__tab--2" data-tab="2">
                        <span>02</span>{ translations[lang].operations.instantLoans }
                    </button>
                    <button className="btn operations__tab operations__tab--3" data-tab="3">
                        <span>03</span>{ translations[lang].operations.instantClosing }
                    </button>
                </div>
                <div
                    className="
            operations__content
            operations__content--1
            operations__content--active
          "
                >
                    <div className="operations__icon operations__icon--1">

                    </div>
                    <h5 className="operations__header">
                        { translations[lang].operations.transfersHeader }
                    </h5>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
                        eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                        ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                        aliquip ex ea commodo consequat.
                    </p>
                </div>
            </div>
        </section>

    </StyledWrapper>
}